'use client';
export default function AboutSection() {
  return (
    <section id="about-1" className="about-section">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
          {/* BOX 1 - Working Time */}
          <div
            className="p-8 border-b md:border-b-0 md:border-r"
            style={{ borderColor: 'rgba(255,255,255,0.2)' }}
          >
            <h5 className="text-white font-bold text-base mb-4">Horaires d'Ouverture</h5>
            <table className="w-full">
              <tbody>
                <tr>
                  <td className="text-white text-sm py-1 opacity-90">Lun – Mer</td>
                  <td className="text-white text-sm py-1 opacity-90 px-2">-</td>
                  <td className="text-white text-sm py-1 opacity-90 text-right">8:00 - 19:00</td>
                </tr>
                <tr>
                  <td className="text-white text-sm py-1 opacity-90">Jeudi</td>
                  <td className="text-white text-sm py-1 opacity-90 px-2">-</td>
                  <td className="text-white text-sm py-1 opacity-90 text-right">8:00 - 18:30</td>
                </tr>
                <tr>
                  <td className="text-white text-sm py-1 opacity-90">Vendredi</td>
                  <td className="text-white text-sm py-1 opacity-90 px-2">-</td>
                  <td className="text-white text-sm py-1 opacity-90 text-right">8:00 - 18:00</td>
                </tr>
                <tr style={{ borderTop: '1px solid rgba(255,255,255,0.3)' }}>
                  <td className="text-white text-sm pt-3 pb-1 opacity-90">Sam - Dim</td>
                  <td className="text-white text-sm pt-3 pb-1 opacity-90 px-2">-</td>
                  <td className="text-white text-sm pt-3 pb-1 opacity-90 text-right">FERMÉ</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* BOX 2 - Doctors Timetable */}
          <div
            className="p-8 border-b md:border-b-0 md:border-r"
            style={{ borderColor: 'rgba(255,255,255,0.2)' }}
          >
            <h5 className="text-white font-bold text-base mb-4">Planning des Médecins</h5>
            <p className="text-white text-sm mb-5" style={{ opacity: 0.85 }}>
              Consultez le planning de nos spécialistes : médecine générale, pédiatrie, gynécologie, radiologie, diabétologie, ophtalmologie et ORL.
            </p>
            <a
              href="#"
              className="inline-block border-2 border-white text-white text-xs font-bold uppercase px-5 py-2 rounded transition-all hover:bg-white"
              style={{ letterSpacing: '0.5px' }}
              onMouseEnter={e => { e.currentTarget.style.color = '#0e5932'; }}
              onMouseLeave={e => { e.currentTarget.style.color = '#fff'; }}
            >
              Voir le Planning
            </a>
          </div>

          {/* BOX 3 - Appointments */}
          <div
            className="p-8 border-b md:border-b-0 md:border-r"
            style={{ borderColor: 'rgba(255,255,255,0.2)' }}
          >
            <h5 className="text-white font-bold text-base mb-4">Prise de Rendez-vous</h5>
            <p className="text-white text-sm mb-5" style={{ opacity: 0.85 }}>
              Prenez rendez-vous facilement avec nos médecins généralistes et spécialistes pour un suivi médical personnalisé.
            </p>
            <a
              href="#"
              className="inline-block border-2 border-white text-white text-xs font-bold uppercase px-5 py-2 rounded transition-all hover:bg-white"
              style={{ letterSpacing: '0.5px' }}
              onMouseEnter={e => { e.currentTarget.style.color = '#0e5932'; }}
              onMouseLeave={e => { e.currentTarget.style.color = '#fff'; }}
            >
              Prendre RDV
            </a>
          </div>

          {/* BOX 4 - Emergency */}
          <div className="p-8">
            <h5 className="text-white font-bold text-base mb-4">Urgences Médicales</h5>
            <h5 className="text-white font-bold text-lg mb-3 flex items-center gap-2">
              <i className="fas fa-phone" style={{ color: '#fbaf45' }}></i>
              +225 00 00 00 00
            </h5>
            <p className="text-white text-sm" style={{ opacity: 0.85 }}>
              Notre équipe médicale est disponible pour les urgences et les évacuations sanitaires en partenariat avec les services locaux.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
